import React from 'react'

const LegendStatsTableTemplate = ({stats}) => {


    return (
        <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped">
                <thead>
                    <tr>
                        <th>Spiller</th>
                        <th>Kamper</th>
                        <th>Mål</th>
                        <th>Assists</th>
                    </tr>
                </thead>
                <tbody>
                    {stats?.map((player, i) => {
                        return (
                            <tr>
                                <td>{player.player_name}</td>
                                <td>{player.fixtures}</td>
                                <td>{player.goals}</td>
                                <td>{player.assists}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>

        </div>
    )
}
export default LegendStatsTableTemplate